import { useState } from "react";

import {
  DateRangeCalendar,
  getFriendlyDate,
  type IsoDateRange,
} from "@vellum/ui";
import { usePayroll } from "@/lib/payroll/PayrollProvider";

export function PayrollWindowPage() {
  const { payrollWindow, setPayrollWindow } = usePayroll();
  const [draft, setDraft] = useState<IsoDateRange | undefined>();
  const [saved, setSaved] = useState(false);

  const complete = draft?.end != null;

  const save = () => {
    if (!draft?.end) {
      return;
    }
    // Mock only — no payroll window API exists yet (PEAK-318).
    setPayrollWindow({ start: draft.start, end: draft.end });
    setDraft(undefined);
    setSaved(true);
  };

  return (
    <div className="max-w-2xl">
      <div className="mb-6 rounded-lg border border-gray-200 bg-white p-4 text-sm text-gray-700">
        Current payroll window:{" "}
        <span className="font-medium">
          {getFriendlyDate(payrollWindow.start)} –{" "}
          {getFriendlyDate(payrollWindow.end)}
        </span>
        {saved ? (
          <span className="ml-2 font-medium text-green-700">Saved ✓</span>
        ) : null}
      </div>

      <div className="inline-block rounded-lg border border-gray-200 bg-white p-5 shadow-sm">
        <DateRangeCalendar
          value={draft ?? payrollWindow}
          onRangeSelect={(range) => {
            setSaved(false);
            setDraft(range);
          }}
        />
        <p className="mb-0 mt-3 text-xs text-gray-500">
          Click a start day, then an end day, to select a new window.
          {draft && !complete
            ? ` Start: ${getFriendlyDate(draft.start)} — now pick an end day.`
            : ""}
        </p>
      </div>

      <div className="mt-4 flex items-center gap-3">
        <button
          type="button"
          onClick={save}
          disabled={!complete}
          className="rounded-md bg-green-700 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-green-700/90 disabled:cursor-not-allowed disabled:opacity-40"
        >
          Set payroll window
        </button>
        {complete && draft?.end ? (
          <span className="text-sm text-gray-600">
            New window: {getFriendlyDate(draft.start)} –{" "}
            {getFriendlyDate(draft.end)}
          </span>
        ) : null}
      </div>
    </div>
  );
}
